import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  list: {
    padding: 0,
  },
}));

export default useStyles;
